import Api from './index'
import { API_URL } from '../constants'

class Agencies extends Api {
  getAgencyListing(id, params) {
    return this.get('/', { params })
  }

  getAgencyById(id) {
    return this.get(`${id}`)
  }

  update(id, data) {
    return this.patch(`${id}/`, { data })
  }
}

export default new Agencies({
  baseURL: `${API_URL}agencies/`,
})
